import { LoadingAnimation } from '@components/shared/Lottie/LoadingAnimation'

const MainLandingPageLoader = () => {
  return (
    <div className='fixed flex items-center justify-center'>
      <div className='text-center'>
        <LoadingAnimation width={200} height={200} />
      </div>
    </div>
  )
}

export default MainLandingPageLoader
